import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal } from "@telia/teddy";
import DekningskartIframe from "../../atoms/DekningskartIframe/DekningskartIframe";
import "./DekningskartModal.less";

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

const DekningskartModal: React.FC<Props> = ({ isOpen, onClose }) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const dragState = useRef<{ startX: number; startY: number; originX: number; originY: number } | null>(null);

    const onMouseDown = useCallback(
        (e: React.MouseEvent) => {
            dragState.current = { startX: e.clientX, startY: e.clientY, originX: position.x, originY: position.y };

            const onMouseMove = (ev: MouseEvent) => {
                if (!dragState.current) return;
                setPosition({
                    x: dragState.current.originX + ev.clientX - dragState.current.startX,
                    y: dragState.current.originY + ev.clientY - dragState.current.startY,
                });
            };
            const onMouseUp = () => {
                dragState.current = null;
                window.removeEventListener("mousemove", onMouseMove);
                window.removeEventListener("mouseup", onMouseUp);
            };
            window.addEventListener("mousemove", onMouseMove);
            window.addEventListener("mouseup", onMouseUp);
        },
        [position],
    );

    useEffect(() => {
        if (!isOpen) setPosition({ x: 0, y: 0 });
    }, [isOpen]);

    return (
        <Modal open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <Modal.Overlay className="dekningskart-modal">
                <Modal.Content
                    className="dekningskart-modal__content"
                    style={{ transform: `translate(${position.x}px, ${position.y}px)` }}
                >
                    <Modal.Group variant="title" className="dekningskart-modal__title-group" onMouseDown={onMouseDown}>
                        <Modal.Title as="h3">Dekningskart</Modal.Title>
                    </Modal.Group>
                    <Modal.Close
                        aria-label="lukk"
                        slot="floating"
                        onClick={onClose}
                        className="dekningskart-modal__close"
                    />
                    <Modal.Group className="dekningskart-modal__iframe-group">
                        <DekningskartIframe className="dekningskart-modal__iframe" />
                    </Modal.Group>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};

export default DekningskartModal;
